import React from "react";
import { View, Text, TouchableOpacity  } from "react-native";
import { Feather } from "@react-native-vector-icons/feather";
import PatientEditImage from "./PatientEditImage";
import PatientRecords from "./PatientRecords";

const patientFields = ()=>[
  { key:"name", label:"Name", isDisplayed:false, skipIfEmpty:false, isEditable:true },
  { key:"species_name", label:"Species", isDisplayed:true, skipIfEmpty:true, isEditable:true, selectValueKey:"species_id", selectOptionsKey:"speciesList" },
  { key:"breed_name", label:"Primary Breed", isDisplayed:true, skipIfEmpty:true, isEditable:true, selectValueKey:"breed_id", selectOptionsKey:"breedsList" },
  { key:"second_breed_name", label:"Secondary Breed", isDisplayed:true, skipIfEmpty:true, isEditable:true, selectValueKey:"second_breed_id", selectOptionsKey:"breedsList", isOptional:true },
  { key:"gender", label:"Gender", isDisplayed:true, skipIfEmpty:true, isEditable:true, selectValueKey:"gender", selectOptionsKey:"gendersList" },
  { key:"weight", label:"Weight", isDisplayed:true, skipIfEmpty:true, isEditable:true },
  { key:"birth_date", label:"Birth Date", isDisplayed:true, skipIfEmpty:true, isEditable:true, isDate:true, format:window.main.lib.formatBirthdate },
  { key:"color", label:"Color", isDisplayed:true, skipIfEmpty:true, isEditable:true },
  { key:"microchip_implant_date", label:"Microchip Implant Date", isDisplayed:true, skipIfEmpty:true, isEditable:true, isDate:true, format:window.main.lib.dateFormat },
  { key:"microchip_number", label:"Microchip #", isDisplayed:true, skipIfEmpty:true, isEditable:true },
  { key:"microchip_provider", label:"Microchip Provider", isDisplayed:true, skipIfEmpty:true, isEditable:true },
  { key:"has_memberships", label:"Has Membership", format:(val)=>(!!val?"Yes":"No"), isDisplayed:true, skipIfEmpty:false, isEditable:false },
  { key:"last_vaccination", label:"Last Vaccination", isDisplayed:true, skipIfEmpty:true, isEditable:false, format:window.main.lib.dateFormat },
  { key:"current_medications", label:"Current Medications", isDisplayed:true, skipIfEmpty:true, isEditable:false },
];

const genderTypes = ()=>[
  { id: "male", name: "Male" },
  { id: "male-intact", name: "Male (Intact)" },
  { id: "neutered", name: "Male (Neutered)" },
  { id: "female", name: "Female" },
  { id: "female-intact", name: "Female (Intact)" },
  { id: "spayed", name: "Female (Spayed)" },
];

const getGenderTitle = (_value) => {
  const _match = genderTypes().find(o=>(o.id===_value));
  return (_match?.name || "");
};

// Private helper component
const FieldRow = ({ patientObj, fieldObj }) => {
  const _theme = window.main.theme;
  // const display = typeof format === ("function" ? format(value) : (value == null || value === "" || (typeof value === "string" && value.trim() === "") ? "None" : value));
  const _value = (patientObj[fieldObj.key] || "");
  const _display_value = (typeof(fieldObj.format)==="function" ? fieldObj.format(_value) : (!!fieldObj.selectOptionsKey&&fieldObj.selectOptionsKey==="gendersList"&&!!_value) ? getGenderTitle(_value) : _value);
  return (
    <Text style={{marginBottom:12,lineHeight:22}}>
      <Text style={{fontWeight:"600",marginRight:8}}>{fieldObj.label}:</Text><Text style={{fontWeight:"400"}}>{_display_value}</Text>
    </Text>
  );
};

const PatientDetailsComponent = ({ patient, onImageChange, onEdit, containerStyle }) => {
  const _theme = window.main.theme;
  if (!patient) {
    return null;
  }
  return (
    <View style={{backgroundColor:_theme.colors.mode.containerBackgroundColor,borderRadius:_theme.borderRadius,flexDirection:"column",minHeight:540,padding:24,position:"relative",width:"100%",...window.main.theme.boxShadowStyle, ...containerStyle}}>
      <TouchableOpacity onPress={onEdit} style={{position:"absolute",right:12,top:12,zIndex:10}} accessibilityRole="button" accessibilityLabel="Edit Details">
        <Feather name="edit-2" size={20} color={_theme.colors.mode.textColor} style={{cursor:"pointer",padding:4}} />
      </TouchableOpacity>
      <View style={{flexDirection:"row",alignItems:"flex-start",marginBottom:18}}>
        <PatientEditImage profile_image_id={patient.profile_image_id} onImageChange={onImageChange} />
        <View style={{marginLeft:20,marginTop:4,flex:1,flexDirection:"row",alignItems:"flex-start",justifyContent:"space-between"}}>
          <Text style={{color:_theme.colors.mode.textColor,flexShrink:1,fontSize:22,fontWeight:"bold",marginRight:12}} numberOfLines={1} ellipsizeMode="tail">
            {patient.name}
          </Text>
        </View>
      </View>

      {/* FIELD ROWS */}
      <View style={{color:_theme.colors.mode.textColor,marginTop:4}}>
        {patientFields().map((fieldObj) => {
          if (!fieldObj.isDisplayed || (!!fieldObj.skipIfEmpty && !patient[fieldObj.key])) {
            return null;
          }
          return (
            <FieldRow key={`${fieldObj.key}_${patient.patient_id}`} patientObj={patient} fieldObj={fieldObj} />
          );
        })}
      </View>
      <PatientRecords patient={patient} />
    </View>
  );
};

export default PatientDetailsComponent;
export { patientFields, genderTypes };
